import { Calendar, CheckCircle2, Mail, Video } from "lucide-react";
import { ThankYouPage } from "@/components/site/ThankYouPage";
import { MasterclassRegistrationDetails } from "@/components/masterclass/RegistrationDetails";
import { ROUTES } from "@/content/offers";

const MasterclassThankYou = () => (
  <ThankYouPage
    metaTitle="You're Registered · Masterclass · Dr. Sully Speaks"
    metaDescription="Your masterclass seat is confirmed. Here's exactly what happens next and how to get the most out of your session with Dr. Sully."
    path="/masterclass/thank-you"
    eyebrow="Registration confirmed"
    heading="Your seat is saved"
    intro="You're on the list. Everything you need arrives by email — here's what to expect and how to show up ready."
    steps={[
      {
        icon: Mail,
        title: "Confirmation email",
        when: "Within 5 minutes",
        desc: "A confirmation lands in your inbox with the join link. If you don't see it, check spam or promotions and mark it as safe so reminders reach you.",
      },
      {
        icon: Calendar,
        title: "Add it to your calendar",
        when: "Do this now",
        desc: "Use the calendar link in the email to block the full 90 minutes. Attendees who calendar it are far more likely to actually show — and the live Q&A is where the real work happens.",
      },
      {
        icon: Video,
        title: "Join live",
        when: "Session day",
        desc: "You'll get a reminder 24 hours and 1 hour before. Join from a quiet space with something to write on — you'll be building your own MAKECHANGE plan in real time.",
      },
      {
        icon: CheckCircle2,
        title: "Replay + next steps",
        when: "After the session",
        desc: "The replay and the worksheet go out afterward, along with an invitation to go deeper if you want personal support applying the framework.",
      },
    ]}
    details={<MasterclassRegistrationDetails />}
    primary={{ label: "Start Your Free Make Change Scan", href: ROUTES.scan }}
    secondary={[
      {
        label: "Grab the free starter kit",
        href: "/free",
        desc: "The MAKECHANGE Playbook PDF, 7-day mini-course, and a sample chapter — a head start before the session.",
      },
      {
        label: "Apply for a strategy session",
        href: "/strategy-session",
        desc: "Want one-on-one help now? Tell us your situation and we'll review your fit personally.",
      },
    ]}
    footnote="Didn't get your confirmation email? Check spam first, then reply to any email from Dr. Sully Speaks and we'll resend your access."
  />
);

export default MasterclassThankYou;
